import axios from "axios";
import { IHolidayFormFilter, IHolidayRow, IMsFormFilter, IMsRow } from "../types";

const MS_HOLIDAY_GET_MS_FILTERS = "/network/v1/get-location-filter";
const MS_HOLIDAY_GET_MOBILITY_STORES = "/network/v1/get-ms-list-for-holiday";
const MS_HOLIDAY_GET_HOLIDAYS = "/network/v1/get-public-holiday-list";
const MS_HOLIDAY_INSERT_HOLIDAY = "/network/v1/insert-public-holiday";
const MS_HOLIDAY_ASSOCIATE_HOLIDAYS = "/network/v1/insert-ms-public-holiday";

interface IPagination {
   totCount?: number,
   pagination?: number,
   startIndex?: number,
   endIndex?: number,
   sortBy?: {
      field: string,
      order: "asc" | "desc",
   },
}

export async function getMsFilters(req: { tenants: string[] }) {
   const response = await axios.post(MS_HOLIDAY_GET_MS_FILTERS, req);
   return response.data;
}

export async function getMobilityStores(req: { filter: { tenants: string[] } & IMsFormFilter, paramRequest: IPagination }) {
   const response = await axios.post(MS_HOLIDAY_GET_MOBILITY_STORES, req);
   return response.data;
}

export async function getHolidays(req: { paramRequest: IPagination } & IHolidayFormFilter) {
   const response = await axios.post(MS_HOLIDAY_GET_HOLIDAYS, req);
   return response.data;
}

export async function associateHolidays(req: { holidayList: IHolidayRow[], mobilityStoreList: IMsRow[], }) {
   const response = await axios.post(MS_HOLIDAY_ASSOCIATE_HOLIDAYS, req);
   return response.data;
}

export async function insertHoliday(req: IHolidayRow) {
   const response = await axios.post(MS_HOLIDAY_INSERT_HOLIDAY, [{ ...req, id: undefined }]);
   return response.data;
}

export async function editHolidays(req: IHolidayRow[]) {
   const response = await axios.post(MS_HOLIDAY_INSERT_HOLIDAY, req);
   return response.data;
}
